import React, { useState, useEffect } from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DataDefinitionList,
  Notification,
  ButtonOBSOLETED,
  Loader,
  Message
} from '../../web.common';
import { Divider, DetailsRightBar, NoLink, Link } from './DetailsRightBar';
import withApi from '../higherOrderComponents/withApi';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import {
  DisplayGuid,
  DisplayDate,
  DisplayArea,
  DisplayAddress
} from '../items';
import ReactSelect from 'react-select';
import AsyncSelect from "react-select/async";
import ImageCropper from '../misc/ImageCropper.js';
import FacilityTextsTable from './FacilityTextsTable';

export const Image = ({ link, type, onClick }) => {
  if (link == null || link.trim() == '') {
    return '';
  }

  type = type ? `-${type}` : '';

  let style = {
    minWidth: '200px',
    opacity: '1',
    position: 'relative',
    top: '100%',
    marginTop: '2%',
    maxWidth: '60%',
  }

  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}.*/gi;

  const isGuid = regexExp.test(link);

  let src;
  if (link.startsWith('data:image/') || link.startsWith('http')) {
    src = link;
  } else {
    src = `http://static.wannasport.dk/images/${link}${type}`;
  }
  return (
      <img
        src={src}
        style={style}
        onClick={onClick}
      />
  )
}

const FacilityInternal = ({
  api,
  match: {
    params: { facilityId }
  },
  history
}) => {

  const [data, setData] = useState(null);
  const [isEditing, doEdit] = useState(null);
  const [editedNotification, setNotification] = useState(null);
  const [lockersData, setLockersData] = useState(null);
  const [facilityTexts, setFacilityTexts] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(null);
  const [pictureLink, setPictureLink] = useState(null);
  const [format, setFormat] = useState('image/png');
  const [size, setSize] = useState(null);
  const [listPreview, setListPreview] = useState(null);
  const [squarePreview, setSquarePreview] = useState(null);
  const [hugePreview, setHugePreview] = useState(null);
  const [picturePreviewAsBase64, setPicturePreviewAsBase64] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "20%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top"
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0"
  };

  const containerStyle = {
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    border: "1px solid #e5e5e5",
    padding: "1.2rem"
  };

  const textAreaStyle = {
    width: '100%'
  };
  const inputStyle = { marginLeft: '0%' }

  const squaredSize = {
    width: 80,
    height: 80
  }
  const bannerSize = {
    width: 240,
    height: 144
  }
  const hugeSize = {
    width: 1015,
    height: 425
  }

  useEffect(() => {
    async function loadFromApi() {
      const lockerResponse = await api.lockers.getLockersByFacilityId(facilityId);

      if (lockerResponse.success) {
        setLockersData(lockerResponse.data);
      }

      const facility = await api.facilities.getFacility(facilityId);
      setData(facility);

      loadFacilityTexts();

      setPicturePreviewAsBase64(facility.PicturePreview);
      setListPreview(facility.PlacePhotoListPreviewUrl);
      setSquarePreview(facility.PlacePhotoSquarePreviewUrl);
      setHugePreview(facility.PlacePhotoHugePreviewUrl);
    }

    if (!data) {
      loadFromApi();
    }
  }, [data]);

  // The editorial texts of this facility, listed under the main block. Loaded apart from the
  // facility itself so a failure here leaves the facility screen working, and so the list can be
  // refreshed on its own after a delete.
  const loadFacilityTexts = async () => {
    try {
      const texts = await api.facilityContent.searchFacilityTexts({ filters: { facilityId } });
      setFacilityTexts(Array.isArray(texts) ? texts : []);
    } catch (error) {
      setFacilityTexts([]);
    }
  };

  const deleteFacilityText = async (row) => {
    const language = row.languageName || row.language;
    if (!window.confirm(`Delete the ${language} texts of this facility? The page goes back to the generated ones.`)) {
      return;
    }
    try {
      await api.facilityContent.deleteFacilityText({ facilityId, contentLanguage: row.language });
      await loadFacilityTexts();
    } catch (error) {
      setNotification(new Message('error', 'Unable to delete the facility text'));
    }
  };

  const handleImageChange = (e, ratio, path) => {
    if (e.target.files && e.target.files.length > 0) {
      let pictureSize;
      switch (path) {
        case 'logo':
          pictureSize = squaredSize;
          break;
        case 'squared':
          pictureSize = squaredSize;
          break;
        case 'list':
          pictureSize = bannerSize;
          break;
        case 'huge':
          pictureSize = hugeSize;
          break;
      }

      const file = e.target.files[0];
      const fileFormat = file.type;
      const postfix = `-${path}`;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFormat(fileFormat);
        setImageSrc(reader.result);
        setAspectRatio(ratio);
        setPictureLink(postfix);
        setSize(pictureSize);
      };
    }
  };

  const handleImageCropped = async (croppedImage, postfix) => {
    const response = await api.products.saveImage(croppedImage, postfix, format);

    if (!response.success) {
      setNotification(new Message('error', response.message));
    } else {
      setNotification(new Message('success', 'Image saved successfully.'));
      let propertyName;

      if (response.data.includes('logo')) {
        propertyName = 'PlaceLogoUrl';
      } else if (response.data.includes('squared')) {
        propertyName = 'PlacePhotoSquareUrl';
      } else if (response.data.includes('list')) {
        propertyName = 'PlacePhotoListUrl';
      } else if (response.data.includes('huge')) {
        propertyName = 'PlacePhotoHugeUrl';
      }
      doEdit({ ...isEditing, [propertyName]: response.data })
    }

    setImageSrc(null);
    setAspectRatio(null);
    setPictureLink(null);
    setFormat('image/png');
    setSize(null);
  };


  const onImageCancel = () => {
    setImageSrc(null);
    setAspectRatio(null);
    setPictureLink(null);
    setFormat('image/png');
    setSize(null);
  };

  const handleSquarePreviewPicture = async (picture, postfix) => {
    const preview = await api.products.generatePreview(picture);
    const response = await api.products.saveImage(preview, postfix, format);
    if (!response.success) {
      setNotification(new Message('error', response.message));
      setSquarePreview('');
    } else {
      setSquarePreview(response.data);
    }
  }

  const handleListPreviewPicture = async (picture, postfix) => {
    const preview = await api.products.generatePreview(picture);
    setPicturePreviewAsBase64(preview);
    const response = await api.products.saveImage(preview, postfix, format);
    if (!response.success) {
      setNotification(new Message('error', response.message));
      setListPreview('');
    } else {
      setListPreview(response.data);
    }
  }

  const handleHugePreviewPicture = async (picture, postfix) => {
    const preview = await api.products.generatePreview(picture);
    const response = await api.products.saveImage(preview, postfix, format);
    if (!response.success) {
      setNotification(new Message('error', response.message));
      setHugePreview('');
    } else {
      setHugePreview(response.data);
    }
  }

  const mappedLockers = lockersData ? lockersData.map(({ id, name }) => ({ value: id, label: name })) : { value: '', label: '' };

  const editFacility = async (event, receivedProps) => {

    receivedProps = {
      ...receivedProps,
      PlacePhotoUrl: receivedProps.PlacePhotoUrl || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
      PlacePhotoListPreviewUrl: listPreview,
      PlacePhotoSquarePreviewUrl: squarePreview,
      PlacePhotoHugePreviewUrl: hugePreview,
      PicturePreview: picturePreviewAsBase64
    };

    console.log(JSON.stringify(receivedProps));
    const validationResponse = validateForm(receivedProps);

    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }
    await api.facilities.editFacilityData(receivedProps);
    setNotification(new Message('success', 'Facility updated successfully.'));
    const facility = await api.facilities.getFacility(facilityId);
    setData(facility);
    doEdit(null);
  }

  const lookupProvider = (value) => {
    const result = api.providers.lookupByNameOrId(value);
    return result;
  }

  const lookupArea = async (value) => {
    const result = await api.areas.lookupByNameOrId(value);
    return result;
  }

  const validateForm = (propsToValidate) => {

    const emptyFields = [];
    let response = {
      success: false,
      type: 'error',
      message: ''
    };

    if (propsToValidate.Name.trim() == '') {
      emptyFields.push('Name');
    }
    if (propsToValidate.PlaceAddress.String.trim() == '') {
      emptyFields.push('Address');
    }
    if (propsToValidate.PlaceAddress.Location.Longitude == '' || !propsToValidate.PlaceAddress.Location.Longitude) {
      emptyFields.push('Longitude');
    }
    if (propsToValidate.PlaceAddress.Location.Latitude == '' || !propsToValidate.PlaceAddress.Location.Latitude) {
      emptyFields.push('Latitude');
    }

    if (emptyFields.length == 1) {
      response.message = `Unable to save. The ${emptyFields} field is mandatory.`
    } else if (emptyFields.length > 1) {
      response.message = `Unable to save. ${emptyFields.join(', ')} are mandatory.`
    } else {
      response.success = true;
      response.type = 'success';
    }

    return response;
  }

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle={`Facility`}
            documentDescription={`Facility`}
          />
          {
            data && !imageSrc ?
              (<React.Fragment>
                <h2 className='main-page-header main-page-header-with-subheader'>
                  Facility
                </h2>
                <h5 className='main-page-subheader'>{data.Name}</h5>
                <br />
                {
                  isEditing ?
                    <React.Fragment>
                      <div style={containerStyle}>
                        <div style={rowStyle}>
                          <label for="name" style={formLabelStyle}>{"Name*"}</label>
                          <span style={formSpanStyle} >
                            <input name="name" id="name"
                              placeholder='Name'
                              value={isEditing.Name}
                              onChange={({ target }) => doEdit({ ...isEditing, Name: console.log(target.value) || target.value })} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="address" style={formLabelStyle}>{'Address*'}</label>
                          <span style={formSpanStyle} >
                            <input name="address" id="address"
                              placeholder='Address'
                              value={isEditing.PlaceAddress.String}
                              onChange={({ target }) =>
                                doEdit(
                                  {
                                    ...isEditing,
                                    PlaceAddress: {
                                      ...isEditing.PlaceAddress,
                                      String: console.log(target.value) || target.value
                                    }
                                  })
                              }
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="latitude" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <input name="latitude" id="latitude"
                              placeholder='Place Latitude'
                              value={isEditing.PlaceAddress.Location.Latitude}
                              onChange={({ target }) =>
                                doEdit({
                                  ...isEditing,
                                  PlaceAddress: {
                                    ...isEditing.PlaceAddress,
                                    Location: {
                                      ...isEditing.PlaceAddress.Location,
                                      Latitude: console.log(target.value) || target.value,
                                    },
                                  },
                                })
                              }
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="longitude" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <input name="longitude" id="longitude"
                              value={isEditing.PlaceAddress.Location.Longitude}
                              placeholder='Place Longitude'
                              onChange={({ target }) =>
                                doEdit({
                                  ...isEditing,
                                  PlaceAddress: {
                                    ...isEditing.PlaceAddress,
                                    Location: {
                                      ...isEditing.PlaceAddress.Location,
                                      Longitude: console.log(target.value) || target.value,
                                    },
                                  },
                                })
                              } />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="email" style={formLabelStyle}>Email</label>
                          <span style={formSpanStyle} >
                            <input name="email" id="email"
                              placeholder='Email'
                              value={isEditing.PlaceEmailAddress.Email}
                              onChange={({ target }) =>
                                doEdit(
                                  {
                                    ...isEditing,
                                    PlaceEmailAddress: {
                                      ...isEditing.PlaceEmailAddress,
                                      Email: console.log(target.value) || target.value
                                    }
                                  })
                              }
                            />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="provider" style={formLabelStyle}>
                            {'Provider*'}
                          </label>
                          <span style={formSpanStyle}>
                            <AsyncSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              defaultOptions
                              value={isEditing.Provider}
                              cacheOptions
                              onChange={(selection) =>
                                doEdit({
                                  ...isEditing,
                                  Provider: console.log(selection) || selection,
                                })
                              }
                              loadOptions={async (inputValue) => lookupProvider(inputValue)}
                            ></AsyncSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="area" style={formLabelStyle}>
                            {'Area*'}
                          </label>
                          <span style={formSpanStyle}>
                            <AsyncSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              defaultOptions
                              value={isEditing.Area}
                              cacheOptions
                              onChange={(selection) =>
                                doEdit({
                                  ...isEditing,
                                  Area: console.log(selection) || selection,
                                })
                              }
                              loadOptions={async (inputValue) => lookupArea(inputValue)}
                            ></AsyncSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="locker" style={formLabelStyle}>
                            Locker
                          </label>
                          <span style={formSpanStyle}>
                            <ReactSelect
                              className="react-select-filters-section"
                              classNamePrefix="react-select-filters-section-prefix"
                              isClearable={true}
                              value={mappedLockers.filter(
                                (x) => x.value == isEditing.LockerId
                              )}
                              onChange={(selection) => {
                                doEdit({
                                  ...isEditing,
                                  LockerId: console.log(selection) || (selection ? selection.value : undefined),
                                });
                              }}
                              options={mappedLockers}
                            ></ReactSelect>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}>Logo Url</label>
                          <span style={formSpanStyle} >
                            <input name="logo" id="logo"
                              placeholder='Logo Url'
                              value={isEditing.PlaceLogoUrl}
                              onChange={({ target }) => doEdit({ ...isEditing, PlaceLogoUrl: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={isEditing.PlaceLogoUrl} />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="fileLogoInput">Load a picture:</label>
                          <input style={inputStyle} type="file" id="fileLogoInput" accept="image/*" onChange={(e) => handleImageChange(e, (1), 'logo')} />
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="photo" style={formLabelStyle}>Photo Square Url</label>
                          <span style={formSpanStyle} >
                            <input name="photo" id="photo"
                              placeholder='Photo Square Url'
                              value={isEditing.PlacePhotoSquareUrl}
                              onChange={({ target }) => doEdit({ ...isEditing, PlacePhotoSquareUrl: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={isEditing.PlacePhotoSquareUrl} />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="fileSquareInput">Load a picture:</label>
                          <input style={inputStyle} type="file" id="fileSquareInput" accept="image/*" onChange={(e) => handleImageChange(e, (1), 'squared')} />
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="squarePreviewButton"></label>
                          {isEditing.PlacePhotoSquareUrl && isEditing.PlacePhotoSquareUrl.trim() != '' ?
                            <button onClick={() => handleSquarePreviewPicture(isEditing.PlacePhotoSquareUrl, '-squared-preview')}>Generate Preview</button> :
                            <button disabled>Generate Preview</button>
                          }
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="square-preview" style={formLabelStyle}>{'Photo Square Preview'}</label>
                          <span style={formSpanStyle} >
                            <input style={inputStyle} disabled name="square-preview" id="square-preview"
                              placeholder='Photo Square Preview'
                              value={squarePreview}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={squarePreview} />
                          </span>
                        </div>

                        <hr />
                        <div style={rowStyle}>
                          <label for="photo" style={formLabelStyle}>Photo List Url</label>
                          <span style={formSpanStyle} >
                            <input name="photo" id="photo"
                              placeholder='Photo List Url'
                              value={isEditing.PlacePhotoListUrl}
                              onChange={({ target }) => doEdit({ ...isEditing, PlacePhotoListUrl: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={isEditing.PlacePhotoListUrl} />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="fileListInput">Load a picture:</label>
                          <input style={inputStyle} type="file" id="fileListInput" accept="image/*" onChange={(e) => handleImageChange(e, (240 / 144), 'list')} />
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="listPreviewButton"></label>
                          {isEditing.PlacePhotoListUrl && isEditing.PlacePhotoListUrl.trim() != '' ?
                            <button onClick={() => handleListPreviewPicture(isEditing.PlacePhotoListUrl, '-list-preview')}>Generate Preview</button> :
                            <button disabled>Generate Preview</button>
                          }
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="list-preview" style={formLabelStyle}>{'Photo List Preview'}</label>
                          <span style={formSpanStyle} >
                            <input style={inputStyle} disabled name="list-preview" id="list-preview"
                              placeholder='Photo List Preview'
                              value={listPreview}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={listPreview} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="picturePreview" style={formLabelStyle}>List Preview (base64)</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} rows={3} name="picturePreview" id="picturePreview"
                              placeholder='Picture Preview'
                              value={picturePreviewAsBase64}
                              onChange={({ target }) => {
                                console.log(target.value);
                                setPicturePreviewAsBase64(target.value);
                              }
                              }
                            >
                            </textarea>
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={picturePreviewAsBase64} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="photo" style={formLabelStyle}>Photo Huge Url</label>
                          <span style={formSpanStyle} >
                            <input name="photo" id="photo"
                              placeholder='Photo Huge Url'
                              value={isEditing.PlacePhotoHugeUrl}
                              onChange={({ target }) => doEdit({ ...isEditing, PlacePhotoHugeUrl: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={isEditing.PlacePhotoHugeUrl} />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="fileHugeInput">Load a picture:</label>
                          <input style={inputStyle} type="file" id="fileHugeInput" accept="image/*" onChange={(e) => handleImageChange(e, (1015 / 425), 'huge')} />
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label style={formLabelStyle} htmlFor="hugePreviewButton"></label>
                          {isEditing.PlacePhotoHugeUrl && isEditing.PlacePhotoHugeUrl.trim() != '' ?
                            <button onClick={() => handleHugePreviewPicture(isEditing.PlacePhotoHugeUrl, '-huge-preview')}>Generate Preview</button> :
                            <button disabled>Generate Preview</button>
                          }
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="huge-preview" style={formLabelStyle}>{'Photo Huge Preview'}</label>
                          <span style={formSpanStyle} >
                            <input style={inputStyle} disabled name="huge-preview" id="huge-preview"
                              placeholder='Photo Huge Preview'
                              value={hugePreview}
                            />
                          </span>
                        </div>
                        <br />
                        <div style={rowStyle}>
                          <label for="logo" style={formLabelStyle}></label>
                          <span style={formSpanStyle} >
                            <Image link={hugePreview} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="website" style={formLabelStyle}>Website Url</label>
                          <span style={formSpanStyle} >
                            <input name="website" id="website"
                              placeholder='Website Url'
                              value={isEditing.PlaceWebsiteUrl}
                              onChange={({ target }) => doEdit({ ...isEditing, PlaceWebsiteUrl: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="phoneNumber" style={formLabelStyle}>Phone Number</label>
                          <span style={formSpanStyle} >
                            <input name="phoneNumber" id="phoneNumber"
                              placeholder='Phone Number'
                              value={isEditing.PlacePhoneNumber.Number}
                              onChange={({ target }) =>
                                doEdit(
                                  {
                                    ...isEditing,
                                    PlacePhoneNumber: {
                                      ...isEditing.PlacePhoneNumber,
                                      Number: console.log(target.value) || target.value
                                    }
                                  })
                              }
                            />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="slug" style={formLabelStyle}>Slug</label>
                          <span style={formSpanStyle} >
                            <input name="slug" id="slug"
                              placeholder='Slug'
                              value={isEditing.Slug}
                              onChange={({ target }) => doEdit({ ...isEditing, Slug: console.log(target.value) || target.value })}
                            />
                          </span>
                        </div>
                        <br />
                        <br />
                        <div style={{ justifyContent: 'center', display: 'flex', gap: '1.5rem' }}>
                          <ButtonOBSOLETED
                            type="submit"
                            buttonContent="Save"
                            onClick={async (e) => {
                              await editFacility(e, isEditing);
                            }} />
                          <ButtonOBSOLETED
                            type="reset"
                            buttonContent="Cancel"
                            onClick={async () => {
                              doEdit(null);
                            }} />
                        </div>
                      </div>
                    </React.Fragment> :
                    <DataDefinitionList
                      listData={{
                        Id: <DisplayGuid>{data.Id}</DisplayGuid>,
                        'Name*': data.Name,
                        'Address*': <DisplayAddress>{data.PlaceAddress}</DisplayAddress>,
                        Email: data.PlaceEmailAddress.Email || '',
                        'Provider*': data.ProviderName,
                        'Provider Id': <DisplayGuid baseAnchor='/provider'>{data.ProviderId}</DisplayGuid>,
                        'Area*': <DisplayArea>{data.Area}</DisplayArea>,
                        Locker: data.LockerId ? mappedLockers.filter((x) => x.value == data.LockerId).map((x) => x.label)[0] : '',
                        LockerId: data.LockerId ? <DisplayGuid baseAnchor='/locker'>{data.LockerId}</DisplayGuid> : '',
                        'Logo Url': data.PlaceLogoUrl ? (
                          <>
                            <div>
                              {data.PlaceLogoUrl}
                            </div>
                            <div>
                              <Image link={data.PlaceLogoUrl} />
                            </div>
                          </>
                        ) : '',
                        'Photo Square Url': data.PlacePhotoSquareUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoSquareUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoSquareUrl} />
                            </div>
                          </>
                        ) : '',
                        'Photo Square Preview Url': data.PlacePhotoSquarePreviewUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoSquarePreviewUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoSquarePreviewUrl} />
                            </div>
                          </>
                        ) : '',

                        'Photo List Url': data.PlacePhotoListUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoListUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoListUrl} />
                            </div>
                          </>
                        ) : '',
                        'Photo List Preview Url': data.PlacePhotoListPreviewUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoListPreviewUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoListPreviewUrl} />
                            </div>
                          </>
                        ) : '',
                        'List Preview (base64)': picturePreviewAsBase64 ? (
                          <>
                            <textarea rows={3} disabled>
                              {picturePreviewAsBase64}
                            </textarea>
                            <div>
                              <Image link={picturePreviewAsBase64} />
                            </div>

                          </>
                        ) : '',
                        'Photo Huge Url': data.PlacePhotoHugeUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoHugeUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoHugeUrl} />
                            </div>
                          </>
                        ) : '',
                        'Photo Huge Preview Url': data.PlacePhotoHugePreviewUrl ? (
                          <>
                            <div>
                              {data.PlacePhotoHugePreviewUrl}
                            </div>
                            <div>
                              <Image link={data.PlacePhotoHugePreviewUrl} />
                            </div>
                          </>
                        ) : '',

                        'Website Url': data.PlaceWebsiteUrl || '',
                        'Phone Number': data.PlacePhoneNumber.Number || '',
                        Slug: data.Slug || '',
                        CreatedAt: <DisplayDate>{data.CreatedAt}</DisplayDate>,
                        '':
                          (<div>
                            <br />
                            <ButtonOBSOLETED
                              type="submit"
                              buttonContent="Edit"
                              onClick={() => {
                                doEdit({ ...data, Provider: { value: data.ProviderId, label: data.ProviderName }, Area: { value: data.Area.AreaId, label: data.Area.Name } });
                              }} />
                          </div>)
                      }
                      }
                      classNames={['detail-page-list']}
                    />
                }
                <div style={{ width: '80%', margin: 'auto', marginTop: '2rem' }}>
                  <h3>Facility texts</h3>
                  <div style={{ margin: '1rem 0 1.5rem' }}>
                    <ButtonOBSOLETED
                      buttonColor="primary"
                      type="button"
                      onClick={() => history.push(`/facility-text?facilityId=${facilityId}`)}
                      buttonContent="Add language"
                      ariaLabel="Add a language for this facility"
                      disabled={false}
                    />
                  </div>
                  {facilityTexts.length === 0 ? (
                    <div style={{ padding: '10px 0', color: 'grey' }}>
                      No texts yet: the page uses the generated title, meta and heading.
                    </div>
                  ) : (
                    <FacilityTextsTable
                      rows={facilityTexts}
                      showFacility={false}
                      onRowClick={(row) => history.push(`/facility-text/${row.id}`)}
                      onDelete={deleteFacilityText}
                    />
                  )}
                </div>
                <DetailsRightBar>
                  <Divider>Links</Divider>
                  <Link to={`/provider/${data.ProviderId}`}>{data.ProviderName}</Link>
                  <Link to={`/products?facilityId=${facilityId}`}>Products</Link>
                  <Link to={`/activities?facilityId=${facilityId}`}>Activities</Link>
                  <Divider>Actions</Divider>
                  <NoLink>None</NoLink>
                </DetailsRightBar>
              </React.Fragment>) 
              : imageSrc ? (
                <ImageCropper imageSrc={imageSrc} aspectRatio={aspectRatio} pictureSize={size} format={format} onCancel={onImageCancel} link={pictureLink} onImageCropped={handleImageCropped} />
              )
            :
                <>
                  <br />
                  <br />
                  <Loader />
                </>
            }
        </React.Fragment>)
      }
    </LayoutContext.Consumer>);
}

const Facility = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(FacilityInternal)
));

Facility.requiresLogin = true;
Facility.propTypes = { isLoggedIn: PropTypes.bool };

export default Facility;